import React from "react";

interface CollectiblesTabIconProps {
  className?: string;
}

export const CollectiblesTabIcon = ({
  className,
}: CollectiblesTabIconProps) => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M15.5312 0C15.6562 0 15.7604 0.0625 15.8438 0.1875L18.9688 5.28125C19.0729 5.42708 19.0625 5.57292 18.9375 5.71875L10.3125 15.875C10.2292 15.9583 10.1354 16 10.0312 16C9.92708 16 9.83333 15.9583 9.75 15.875L1.125 5.71875C1 5.57292 0.989583 5.42708 1.09375 5.28125L4.21875 0.1875C4.30208 0.0625 4.40625 0 4.53125 0H15.5312ZM15.0938 1.125H13.0625L14.8125 5H17.4062L15.0938 1.125ZM11.8125 1.125H8.25L6.46875 5H13.5938L11.8125 1.125ZM4.96875 1.125L2.65625 5H5.25L7 1.125H4.96875ZM2.9375 6L7.78125 12L5.21875 6H2.9375ZM6.4375 6L10.0312 14.25L13.625 6H6.4375ZM12.2812 12L17.125 6H14.8438L12.2812 12Z"
      fill="#666666"
    />
  </svg>
);

CollectiblesTabIcon.defaultProps = {
  className: "",
};
